import * as yup from 'yup';
import { errorTexts } from '@features/errors';

export const ordersSchema = yup.object().shape({
  prefixXLSNotification: yup.string().required(errorTexts.required()),
  sessionAbbreviation: yup.string().required(errorTexts.required()),
});
